import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Conversation from '../components/Conversation';

const WrappedConversation = ({ userSub, history }) => {
  const user = useSelector((s) => s.user.user);

  return (
    <Conversation
      user={user}
      history={history}
      match={{
        params: {
          id: userSub,
          type: 'sms',
        },
      }}
    />
  );
};

const ConvoRoom = ({ match: {
  params: { convoId }
}, history }) => {

  return (
    <Box>
      <Card>
        <WrappedConversation
            history={history}
            userSub={convoId}
        />
      </Card>
    </Box>
  );
};

export default ConvoRoom;
